// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";

type $Props = {
  classes: Object,
};

const Elevate = ({ classes }: $Props) => (
  <div className={classes.root}>
    <Typography type="heading2" gutterTop gutterBottom>
      Privacy Policy
    </Typography>
    <Hr />
    <Typography type="body" gutterTop gutterBottom>
      This website application (“Application”) is operated by Elm Street
      Technology, LLC either directly or through one of its affiliates
      (individually and collectively hereinafter referred to as “Elm Street”).
      The Application includes both the Elm Street Website and individual
      websites for real estate agents and brokers (herinafter together referred
      to as the “Website”). When using the Website, your privacy on the Internet
      is of the utmost importance to us. At Elm Street, we want to make your
      experience online both satisfying and safe.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Because we gather certain types of information about our users, we feel
      you should fully understand the terms and conditions surrounding the
      capture and use of that information. This Privacy Policy discloses what
      information we gather and how we use it.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      INFORMATION COLLECTED AND TRACKED BY ELM STREET
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      In general, when you visit our website, you remain anonymous. When you
      open an account on the Website, your Website activity may be tracked by
      the Application and may be viewed, accessed, and tracked by the real
      estate agent or broker connected to the Website you access (your “Agent”
      or “Broker“), and Elm Street, including, without limitation, when you log
      on to the Website, what you view, and information that you save, submit,
      transmit, or post to or from the Website (collectively, “Website
      Activity”); provided, however, that any “Private Notes” created by you on
      the Website are not accessible by your Agent or Broker. Your Agent or
      Broker may transmit your Website Activity to, and share such Activity
      with, its affiliated licensed real estate agents without your notice or
      permission, except for your Private Notes, and your Agent or Broker may
      reassign responsibility for collaborating with you through your Website
      account either to the Broker directly or another Agent affiliated with
      Broker, without prior notice to you or your consent.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      OUR COMMUNICATIONS WITH YOU (TCPA Consent for United States Residents)
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      A. EXPRESS WRITTEN CONSENT. By using the Elm Street Application and
      submitting your contact information, you are providing your express
      written consent to receive communications from Elm Street, Elm Street
      Application or Real Estate Professional Users, at the email address and
      telephone numbers you entered into your account registration or contact
      form, or that you later provide to us or enter into the Elm Street
      Application, via live, automated or prerecorded email, text, or call.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      B. E-MAILS, TEXTS, AND CALLS. These communications may include Elm Street
      Application updates, information about products and services, and
      telemarketing messages, through the use of email, landline phone, cellular
      phone, and text messages (including sms and mms).
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      C. AUTOMATION. Elm Street, Elm Street Application or Real Estate
      Professional Users may contact you via live, automated or prerecorded
      email, text, or call. Your carrier’s standard rates and charges may apply.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      D. NO PURCHASE NECESSARY. Agreeing to these communications is not a
      condition of purchasing any property, goods, or services from us.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      E. REVOKING CONSENT AND OPTING OUT. You may revoke your consent to receive
      communications at any time by replying “stop” to any of our texts, or by
      any other reasonable means. We will make a commercially reasonable effort
      to comply with any communications from you opting out, but reply “stop”
      will automatically revoke your consent to further text communications, and
      we recommend that method. We may take up to 30 days to stop communications
      if you use a method other than the automatic reply “stop.” you consent to
      receive a final text message confirming your opt-out. You may revoke your
      consent to receive email communications by using the “unsubscribe” link in
      an email or by any other reasonable means. We will make a commercially
      reasonable effort to comply with any communications from you opting out of
      email, but “unsubscribe” will automatically revoke your consent to further
      email communications, and we recommend that method. We may take up to 30
      days to stop email communications if you use a method other than
      “unsubscribe”. The “unsubscribe” link will also permit you to stop text
      communications. Your consent here also serves as your express written
      consent to electronic communications from us in the past. You represent
      and warrant that you 1) are at least 18 years old; 2) live in the United
      States (or Canada, in which case the Canadian consents below apply); 3)
      have not registered on a national or statewide Do Not Call list; 4) are
      the account holder for the email addresses and phone numbers you provided,
      or you have authorization from the account holder to give this consent;
      and 5) confirm that the email addresses and phone numbers you provided are
      accurate.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      F. ADDITIONAL COMMUNICATIONS PROVISIONS (FOR RESIDENTS OF CANADA). In
      addition to the consent provided above in the Our Communications With You
      (United States) section, Canadian residents agree to the following
      provisions related to compliance with Canada’s Anti-Spam Legislation
      (“CASL”), Canada’s Personal Information Protection and Electronic
      Documents Act (“PIPEDA”) and Canadian provincial law including Alberta’
      Personal Information Protection Act (“PIPA”), and Quebec’s Act Respecting
      the Protect of Personal Information in the Private Sector, 1) you agree to
      the provisions governing use and disclosure of personal information that
      are found in our Privacy Policy; 2) because the purpose of our
      communications include your interest in our services, our communication
      with you will continue until you revoke your consent or opt-out; and 3)
      your personal information may also be transmitted to, used in, and stored
      in the United States.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      Optional Voluntary Information
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      There are occasions where we may ask you to voluntarily submit additional
      information about yourself, such as your name, address, telephone number,
      and e-mail address. We may also request your credit card number and
      expiration date. We may request this information to register you as an
      account holder, manage your account, be able to better understand your
      needs, adjust our website to your personal preferences, enable you to
      order products and services via the website, enable you to participate in
      any message boards, and send you e-mail and postal mail newsletters and
      announcements, and for other similar business purposes. We give you the
      opportunity to elect not to receive future materials from us.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      Usage Tracking
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      We collect tracking information and monitor traffic patterns throughout
      this website; however, we do not correlate this information with data
      about individual users unless you are a registered account holder. We do
      break down overall usage statistics according to a user’s domain name,
      browser type, and MIME type by reading this information from the browser
      string (information contained in every user’s browser. This information
      allows us to better tailor our content to users’ needs and to help our
      advertisers and sponsors better understand the demographics of our
      audience.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      Other Data Collection
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      We may collect data from or about you in other ways not specifically
      described in this policy. For example, you might contact us with a
      question. We maintain such data like other business records. All opinions,
      ideas, suggestions, and other feedback submitted through our website may
      be used by Elm Street, without any restriction and free of charge, and
      nothing contained in this policy shall limit or otherwise affect this.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      We may also collect non-personally identifiable information such as the
      type of internet browser you are using, the type of computer operating
      system you are using, and the domain name of the website from which you
      linked into our website or an advertisement.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Please note that Elm Street will fully cooperate with any court order or
      other legal process and will provide your personal information to the
      extent required in any legal proceeding.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      USE OF INFORMATION AND PROTECTION OF YOUR PRIVACY
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      As mentioned above, Elm Street may use personal information about you and
      track your usage of our website to register you as an account holder,
      manage your account, be able to better understand your needs, adjust our
      website to your personal preferences, enable you to use the services
      provided by the website, order products and services via the website,
      enable you to communicate with your Agent or Broker, and send you text,
      e-mail and postal mail information, and for other similar business
      purposes. Elm Street does not disclose email addresses, phone numbers, or
      other personal information to any outside parties other than your Agent or
      Broker without your permission, unless such disclosure is necessary to
      comply with applicable law or valid legal process or to protect the
      personal safety of our users or the public. We may use third party
      contractors who can access our databases for the purpose of conducting
      repairs or upgrades to our computer system. We may also use third party
      service providers and give access to your personal information as part of
      the services they provide to us. We hold all such third parties to the
      same privacy standards to which we hold ourselves. We require these third
      parties to use and disclose your personal information only as necessary to
      perform their services.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      We may use third party contractors who can access our databases for the
      purpose of conducting repairs or upgrades to our computer system. We may
      also use third party service providers and give access to your personal
      information as part of the services they provide to us. We hold all such
      third parties to the same privacy standards to which we hold ourselves. We
      require these third parties to use and disclose your personal information
      only as necessary to perform their services.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      CHILDREN
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Consistent with the Federal Children’s Online Privacy Protection Act
      (COPPA), Elm Street will never knowingly request personally identifiable
      information from anyone under the age of 13. If we discover that a child
      under the age of 13 has provided us with any personally identifiable
      information, we will delete that information from our systems.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      COOKIES
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Elm Street may place text files called "cookies" in the browser files of
      your computer. The cookies themselves do not contain personal information,
      although they will enable us to relate your use of this website to
      information that you have specifically and knowingly provided. The only
      personal information cookies can contain is information you supply
      yourself. Cookies can’t read data off your hard disk or read cookie files
      created by other sites. Elm Street uses cookies to track user traffic
      patterns (as described above). We may also use cookies when you register
      for an account. In these situations, a cookie will store useful
      information that enables our website to remember you when you return to
      visit us.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      You can refuse cookies by turning them off in your browser. If you've set
      your browser to warn you before accepting cookies, you will receive the
      warning message with each cookie. You do not need to have cookies turned
      on to use this site. However, you do need cookies to participate actively
      in the message boards and forums. Please refer to your browser
      instructions for information regarding erasing, blocking, and receiving
      warnings for cookies.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      SECURITY
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Elm Street operates secure data networks protected by industry standard
      security protocols, such as (if and where appropriate) firewalls,
      encryption, and password protection systems. Our security and privacy
      policies are periodically reviewed and enhanced as necessary, and only
      authorized individuals have access to the information provided by our
      users.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      UNSUBSCRIBE / OPT-OUT POLICY
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      You may unsubscribe or opt-out of receiving electronic correspondence from
      us by either logging into your account to modify your preferences or
      following any instructions in such electronic correspondence on how to
      unsubscribe or opt-out from that list. The foregoing does NOT opt you out
      of receiving e-mail correspondence about your account.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      Third Party Data Services
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Elevate uses YouTube API Services to set up content syndication and post
      videos to your YouTube channel. By installing the YouTube token to set up
      content syndication and by posting videos to YouTube via Elevate, you are
      agreeing to be bound by the YouTube Terms of Service, available for review
      here:{" "}
      <a href="https://www.youtube.com/t/terms">
        https://www.youtube.com/t/terms.
      </a>{" "}
      When you install the Youtube token, Elevate collects the link to your
      channel and links to the videos you upload. We use this information to
      post videos to your channel on your behalf and display the results in your
      Elevate account. In addition to our normal procedure for deleting stored
      data, you can revoke access for the YouTube token at any time and we will
      delete your channel data and video data stored in Elevate. To do so,
      please visit this link in your Google account:{" "}
      <a href="https://security.google.com/settings/security/permissions">
        https://security.google.com/settings/security/permissions.
      </a>{" "}
      This will not delete your YouTube channel or videos. You can access
      Google's Privacy Policy at any time here:{" "}
      <a href="https://policies.google.com/privacy">
        https://policies.google.com/privacy.
      </a>{" "}
      If you have questions or complaints about our privacy practices, please
      reach out to us at engineering@tryelevate.com
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      LINKS
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      This website may contain links to other websites that are not under our
      control. Elm Street is not responsible for the content or privacy
      practices of those sites, and we provide the links solely for the
      convenience and information of our visitors.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      YOUR CONSENT
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      By using this website, you consent to the collection and use of this
      information by Elm Street and your Agent or Broker. If we decide to change
      our Privacy Policy, we will post those changes on this page so you are
      always aware of what information we collect, how we use it, and under what
      circumstances we disclose it.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      TERMS OF SERVICE
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      BY ACCESSING OR USING THE WEBSITE, YOU AGREE TO BE BOUND BY THE TERMS OF
      SERVICE, INCLUDING THE PROVISION PROVIDING THAT ALL DISPUTES RELATING TO
      THE WEBSITE SHALL BE RESOLVED EXCLUSIVELY THROUGH ARBITRATION.
    </Typography>
    <Typography type="heading5" gutterTop gutterBottom>
      CONTACT US
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      If you have any additional questions or concerns about our Privacy Policy,
      please contact us:
      <br />
      Elm Street Technology, LLC,
      <br />
      5473 Blair Rd Ste. 100, PMB 313671, Dallas, Texas 75321-4227,
      <br />
      508-885-2040,
      <br />
      <a href="mailto:support@elmstreettechnology.com">
        support@elmstreettechnology.com
      </a>
    </Typography>
  </div>
);

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
    maxWidth: "970px",
    margin: "40px auto",
    "& p": {
      maxWidth: "100%",
    },
  },
});

export default withStyles(styles)(Elevate);
